















import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import PatientTreatmentTimeline from '@/components/Patient/PatientTreatmentTimeline.vue';
import { TreatmentEpisode } from '@/models/treatment-episode';
import { UserTreatment } from '@/models/user-treatment';

@Component({
  components: { PatientTreatmentTimeline },
})
export default class TreatmentHistory extends Vue {
  @State((state) => state.patient_detail.treatmentEpisodes) episodes!: TreatmentEpisode[];
  @State((state) => state.patient_detail.treatmentEpisodesLoading) isLoading!: boolean;
  @State((state) => state.treatment_detail.data) activeUserTreatment!: UserTreatment;

  // The memo endpoint is scoped to the patient, so the id travels down with the
  // episodes rather than being read again inside the timeline.
  get patientId(): string {
    return this.$route.params.patientId;
  }

  get filteredEpisodes(): TreatmentEpisode[] {
    const menuId = this.activeUserTreatment && this.activeUserTreatment.menu_id;
    if (!menuId) {
      return this.episodes || [];
    }
    return (this.episodes || []).filter((ep) => {
      // if the episode has no menu info, keep it visible rather than
      // silently hiding it — we can't tell whether it belongs to the
      // current treatment menu, so err on the side of showing it.
      if (!ep.menu) {
        return true;
      }
      return ep.menu.id === menuId;
    });
  }
}
